// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"814aed0f","317":"5282dd2d","406":"a44fed52","453":"c3c453e3","476":"6c903b89","581":"8bc9ca3e","914":"df4d3f7a"}[chunkId] + ".chunk.js";
};